<img
  data-testid="image"
  src="/assets/icon/logo-white.png"
  *transloco="let t"
  [alt]="t('general.website_logo')"
/>
